import { useEffect, useState, createContext } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import database from '../firebase';
import { setAnalyticsUser, clearAnalyticsUser } from '../utils/analytics';

const onAuthStateChange = (callback) => {
    const auth = getAuth();
    return onAuthStateChanged(auth, (user) => {
        if (user) {
            localStorage.setItem("digiquoteUser", user.accessToken);
            const uid = user.uid;
            
            // Get custom claims from Firebase Auth
            user.getIdTokenResult().then(idTokenResult => {
                const claims = idTokenResult.claims;
                
                // Get user document from Firestore
                const docRef = doc(database, "users", uid);
                getDoc(docRef).then(async (docSnap) => {
                    if (docSnap.exists()) {
                        const userData = docSnap.data();
                        const referralSourceId = claims.referralSource || null;

                        // Fetch partner name if referralSource exists
                        let referralSourceName = '';
                        if (referralSourceId) {
                            try {
                                const partnerRef = doc(database, "partners", referralSourceId);
                                const partnerSnap = await getDoc(partnerRef);
                                if (partnerSnap.exists()) {
                                    referralSourceName = partnerSnap.data().name || '';
                                }
                            } catch (error) {
                                console.error("Error fetching partner document:", error);
                            }
                        }

                        const userDataForContext = {
                            uid: uid,
                            email: user.email,
                            phone: userData.phone,
                            firstName: userData.firstName,
                            lastName: userData.lastName,
                            agencyName: userData.agency.agencyName,
                            agencyId: userData.agency.id,
                            isAdmin: claims.isAdmin || false,
                            referralSource: referralSourceId,
                            referralSourceName: referralSourceName
                        };

                        // Set analytics user properties
                        setAnalyticsUser({
                            uid: uid,
                            firstName: userData.firstName,
                            lastName: userData.lastName,
                            agencyName: userData.agency.agencyName,
                            agencyId: userData.agency.id,
                            isAdmin: claims.isAdmin || false,
                            referralSourceId: referralSourceId,
                            referralSourceName: referralSourceName
                        });

                        callback(userDataForContext);
                    } else {
                        console.error("No such document!");
                    }
                }).catch(error => {
                    console.error("Error fetching user document:", error);
                });
            }).catch(error => {
                console.error("Error fetching custom claims:", error);
            });
        } else {
            localStorage.removeItem("digiquoteUser");
            clearAnalyticsUser();
            callback({});
        }
    });
};

export const UserContext = createContext();

export const UserProvider = (props) => {

    const [user, setUser] = useState({});

    useEffect(() => {
        const unsubscribe = onAuthStateChange(setUser);
        return () => {
            unsubscribe();
        }
    }, []);

    return (
        <UserContext.Provider value={user}>
            {props.children}
        </UserContext.Provider>
    );
};
